import React, { Component } from "react";
import Modal from "react-modal";

//Avatars
import koala from "../images/koala.png";
import fox from "../images/fox.png";
import lemur from "../images/lemur.png";
import zebra from "../images/zebra.png";

import "../../../src/styles/scoreBoard.scss";
import "../../styles/scoreBoard.scss";

export default class ScoreBoard extends Component {
  constructor() {
    super();

    this.state = {
      modalIsOpen: true
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }
  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  render() {
    return (
      <div>
        <Modal
          className="Modal card"
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          shouldFocusAfterRender={false}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEsc={false}
          contentLabel="Example Modal"
        >
          <div>
            <div className="Welcome-modal-container">
              <div>
                {this.props.totalScore === 0 ? (
                  <div>
                    <h2>
                      Better Luck Next Time{" "}
                      <span style={{ color: "#52b452" }}>
                        {this.props.username}
                      </span>
                      !{" "}
                    </h2>
                  </div>
                ) : this.props.totalScore <= 1000 ? (
                  <div>
                    <h2>
                      {" "}
                      Well Done{" "}
                      <span style={{ color: "#52b452" }}>
                        {this.props.username}
                      </span>
                      !{" "}
                    </h2>
                  </div>
                ) : this.props.totalScore <= 2000 ? (
                  <div>
                    <h2>
                      {" "}
                      Good Job{" "}
                      <span style={{ color: "#52b452" }}>
                        {this.props.username}
                      </span>
                      !{" "}
                    </h2>
                  </div>
                ) : this.props.totalScore <= 3500 ? (
                  <div>
                    <h2>
                      {" "}
                      Great Job{" "}
                      <span style={{ color: "#52b452" }}>
                        {this.props.username}
                      </span>
                      !{" "}
                    </h2>
                  </div>
                ) : this.props.totalScore <= 5000 ? (
                  <div>
                    <h2>
                      {" "}
                      Fantastic{" "}
                      <span style={{ color: "#52b452" }}>
                        {this.props.username}
                      </span>
                      !{" "}
                    </h2>
                  </div>
                ) : this.props.totalScore > 5000 ? (
                  <div>
                    <h2>
                      {" "}
                      Amazing{" "}
                      <span style={{ color: "#52b452" }}>
                        {this.props.username}
                      </span>
                      !{" "}
                    </h2>
                  </div>
                ) : (
                  <div>
                    <h2>
                      Nice Try{" "}
                      <span style={{ color: "#52b452" }}>
                        {this.props.username}
                      </span>
                      !{" "}
                    </h2>
                  </div>
                )}
              </div>
              <img
                src={
                  localStorage.getItem("avatar") === "Koala"
                    ? koala
                    : localStorage.getItem("avatar") === "Fox"
                    ? fox
                    : localStorage.getItem("avatar") === "Lemur"
                    ? lemur
                    : localStorage.getItem("avatar") === "Zebra"
                    ? zebra
                    : koala
                }
                alt="Koala"
                width="50%"
                height="auto"
              />
              <p>
                Your total score is:
                <span style={{ fontWeight: "900", color: "#52b452dc" }}>
                  {" "}
                  <br />
                  <span className="Modal-score total-score-points">
                    {this.props.totalScore}
                  </span>
                </span>{" "}
              </p>
            </div>

            <button
              className="Continue-button"
              onClick={() => {
                this.closeModal();
                this.props.goToNextRound();
              }}
              disabled={this.props.whichRound === 3}
            >
              Next Round
            </button>

            <button
              className="End-game-button"
              onClick={() => {
                this.closeModal();
                this.props.goToEndScreen();
              }}
            >
              End Game
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}
